<div class="resetPassMainContainer">
    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="resetBlock">
        <img src="assets/logo.svg" width="200px" draggable="false" />
        <input
            type="password"
            id="newPassword"
            [placeholder]="'auth.resetPassword.newPassword' | translate"
            formControlName="newPassword"
            class="form-control"
            aria-label="Small"
            aria-describedby="inputGroup-sizing-sm"
            autocomplete="new-password"
        />
        <button
            type="submit"
            class="validateButton"
            [disabled]="resetForm.invalid"
        >
            {{ "auth.resetPassword.resetButton" | translate }}
        </button>
        <div>
            <a [routerLink]="['/login']">{{
                "auth.forgotPassword.backToLogin" | translate
            }}</a>
        </div>
    </form>
</div>
